import { Notification } from 'expo-notifications';
import React, { useContext } from 'react';
import { StyleSheet } from 'react-native';
import GenericHeader from '../components/headers/GenericHeader';
import NotificationCard from '../components/notification/NotificationCard';
import { NotificationContext } from '../contexts/notification/Store';
// import Notifications from '../components/notification/Notification';

export default function NotificationScreen() {
  const { notif_state, notif_delete } = useContext(NotificationContext)
  return (
    <>
      <GenericHeader
        title='Notifications'
      />
      {/* Previously used to show promotions. Now used to show push notifications */}
      {/* <Notifications /> */}
      {
        notif_state.notifications.map(
          (notification: Notification) => <NotificationCard
            key={notification.request.identifier}
            data={notification}
            remove={() => notif_delete(notification?.request?.identifier || '')}
          />)
      }
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fafafa',
  },
  contentContainer: {
    paddingHorizontal: 16,
  },
  optionIconContainer: {
    marginRight: 12,
  },
  option: {
    backgroundColor: '#fdfdfd',
    paddingHorizontal: 15,
    paddingVertical: 15,
    borderWidth: StyleSheet.hairlineWidth,
    borderBottomWidth: 0,
    borderColor: '#ededed',
  },
  lastOption: {
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  optionText: {
    fontSize: 15,
    alignSelf: 'flex-start',
    marginTop: 1,
  },
});
